/**
 * Cart drawer cross-sell: copies the chosen size from [data-cross-sell-select] into the
 * form's hidden [data-cross-sell-id] input (s-product-form reads `id` from an <input>), and
 * enables the add button only once a size is picked. Delegated on document so it survives
 * the drawer's partial re-renders.
 */
document.addEventListener('change', (event) => {
  const select = event.target;
  if (!(select instanceof HTMLSelectElement) || !select.matches('[data-cross-sell-select]')) return;
  const form = select.form;
  if (!form) return;
  const idInput = form.querySelector('[data-cross-sell-id]');
  const addButton = form.querySelector('[data-cross-sell-add]');
  if (idInput) idInput.value = select.value;
  if (addButton) {
    if (select.value) {
      addButton.removeAttribute('disabled');
      addButton.removeAttribute('aria-disabled');
    } else {
      addButton.setAttribute('disabled', '');
    }
  }
});

/**
 * Prev/next arrows for the cross-sell row. Each click scrolls by about two cards; the arrows
 * disable at the ends. Delegated (click + captured scroll) so it keeps working after the
 * drawer's partials replace the markup.
 */
function syncCrossSellArrows(track) {
  const carousel = track.closest('[data-cross-sell-carousel]');
  if (!carousel) return;
  const prev = carousel.querySelector('[data-cross-sell-prev]');
  const next = carousel.querySelector('[data-cross-sell-next]');
  const max = track.scrollWidth - track.clientWidth - 2;
  const pos = Math.abs(track.scrollLeft);
  if (prev) prev.disabled = pos <= 2;
  if (next) next.disabled = pos >= max;
}

document.addEventListener('click', (event) => {
  const button = event.target.closest?.('[data-cross-sell-prev], [data-cross-sell-next]');
  if (!button) return;
  const track = button.closest('[data-cross-sell-carousel]')?.querySelector('[data-cross-sell-track]');
  if (!track) return;
  const card = track.querySelector('li');
  const step = card ? (card.getBoundingClientRect().width + 12) * 2 : track.clientWidth * 0.8;
  const rtl = getComputedStyle(track).direction === 'rtl';
  let direction = button.hasAttribute('data-cross-sell-next') ? 1 : -1;
  if (rtl) direction *= -1;
  track.scrollBy({ left: step * direction, behavior: 'smooth' });
});

document.addEventListener('scroll', (event) => {
  const track = event.target;
  if (track instanceof HTMLElement && track.matches('[data-cross-sell-track]')) syncCrossSellArrows(track);
}, true);
